module.exports = __webpack_public_path__ + "static/user-preference-df92be9d9cfbc73b72e8a3eb7de17acc.png";